import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class KitQAService extends BaseService {
    static url = "kitQA";
    static apis = {
        that: this,
        getKitQA: {method:'get', path:this.url + "/"},
        add_question: {method:'post', path:this.url + "/add-question"},
        add_answer: { method: "post", path: this.url + "/add-answer" },
        edit_answer: { method: "post", path: this.url + "/edit-answer" },

    };

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("kits");
    }

    getKitQA(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitQAService.apis.getKitQA.path+id,
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }


    addQuestion(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitQAService.apis.add_question.path,
                    method: KitQAService.apis.add_question.method,
                    data: data,
                    authorization: true,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    addAnswer(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitQAService.apis.add_answer.path,
                    method: KitQAService.apis.add_answer.method,
                    data: data,
                    authorization: true,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    editAnswer(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: KitQAService.apis.edit_answer.path,
                    method: KitQAService.apis.edit_answer.method,
                    data: data,
                    authorization: true,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    
}

export default KitQAService;